import getArchiveIssueList from "./getArchiveIssueList";

const archiveWebsiteServices = {
  getArchiveIssueList,
};

export default archiveWebsiteServices;
